import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import SvgIcon from "@material-ui/core/SvgIcon";
import IconButton from "@material-ui/core/IconButton";
import { withSnackbar } from "notistack";

import { authWrapper } from "../../../auth";

import SERVER_ADDRESS from "../../../config";
import store from "../../../reduxstore";

//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

//Main Component
function DeleteDialogButton(props) {
  const [open, handleClickOpen, handleClose] = useDialog();

  const { button, buttonText, warningText, deleteUrl, freshData } = props;
  const fullDeleteUrl = SERVER_ADDRESS + deleteUrl;

  //delte from the server
  const handleSubmit = postUrl => {
    return () => {
      fetch(postUrl, {
        method: "DELETE",
        headers: {
          Accept: "application/*, text/plain, */*"
        },
        mode: "cors",
        credentials: "include"
      })
        .then(res => {
          console.log(res.status);
          if (!res.ok) {
            throw Error(res.statusText);
          }

          handleClose();
          //提交成功后的反馈SnackBar
          if (freshData) {
            freshData();
          }
          props.enqueueSnackbar("删除成功", {
            variant: "success"
          });
          return null;
        })
        .catch(error => {
          //失败后显示错误SnackBar
          // console.log(error);
          props.enqueueSnackbar("删除失败,资源不存在或受保护", {
            variant: "error"
          });
        });
    };
  };

  return (
    <>
      {button ? (
        <Button
          onClick={handleClickOpen}
          color="secondary"
          component="span"
          size="small"
        >
          {buttonText}
        </Button>
      ) : (
        <IconButton onClick={handleClickOpen} title={buttonText}>
          <SvgIcon>
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          </SvgIcon>
        </IconButton>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          <div
            style={{
              display: "inline-flex",
              alignItems: "center"
            }}
          >
            <SvgIcon color="error">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
            </SvgIcon>
            确定删除?
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {warningText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            取消
          </Button>
          <Button
            onClick={handleSubmit(fullDeleteUrl)}
            color="primary"
            autoFocus
          >
            删除
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const withSnackbarDeleteDialogButton = withSnackbar(DeleteDialogButton);
const AuthDeleteDialogButton = authWrapper(["教师", "学生"])(
  withSnackbarDeleteDialogButton
);

export default AuthDeleteDialogButton;
